var $ = jQuery.noConflict();

$(document).ready(function () {
  console.log("jquery");

});

var check_sn_data = {
  commandID: '/deviceSnCheck',
  sn: ""
};
var state = 'default';
var imkeyTime = '';
var langAttributeValue = document.querySelector('html').getAttribute('lang');

function formatDate(dateString) {
  // 将输入的日期字符串按 '-' 分割成数组
  const dateParts = dateString.split('-');

  // 获取年、月、日
  const year = dateParts[0];
  const month = dateParts[1];
  const day = dateParts[2];

  // 返回格式化后的日期字符串
  return `${year}年${month}月${day}日`;
}


document.addEventListener('DOMContentLoaded', function () {
  const fetchSNInput = document.getElementById('imkey-sn');
  const fetchErrSN = document.getElementById('sn-err');
  const fetchDataSlider = document.getElementById('check-sn-slider');
  const domSliderTip = document.getElementById('slider-tip');
  const fetchDataButton = document.getElementById('check-sn-button');
  const fetchDataResult = document.getElementById('fetch-data-result');

  const divCheck = document.getElementById('div-check');
  const divPass = document.getElementById('div-result-pass');
  const divInactive = document.getElementById('div-result-inactive');
  const divFailed = document.getElementById('div-result-failed');
 
  init();

  fetchSNInput.addEventListener('input', function () {
    var inputSN = fetchSNInput.value;
    if (inputSN == "") {
      if (fetchSNInput.classList.contains('input-error')) {
        fetchSNInput.classList.remove('input-error');
      }
      fetchErrSN.hidden = true;
    }
    clearSlider();
    const regex = /^01[2-9A-HJ-NP-Z]{14}$/;
    if (inputSN != "" && regex.test(inputSN)) {
      if (fetchSNInput.classList.contains('input-error')) {
        fetchSNInput.classList.remove('input-error');
      }
      fetchErrSN.hidden = true;
      fetchDataSlider.disabled = false;
    }
  });

  fetchSNInput.addEventListener('blur', function () {
    //1.判断SN输入的是否正确
    var inputSN = fetchSNInput.value;
    if(inputSN == "")
    {
      return;
    }
      
    const regex = /^01[2-9A-HJ-NP-Z]{14}$/;
    if (!regex.test(inputSN)) {
      fetchSNInput.classList.add('input-error');
      fetchErrSN.innerHTML = langAttributeValue == 'zh-CN' ? '您输入的 SN 码格式不正确，请重新输入' : 'Incorrect format of SN code. Please enter it again';
      fetchErrSN.hidden = false;
      fetchDataSlider.disabled = true;
      return;
    }
    //2.隐藏错误提示
    if (fetchSNInput.classList.contains('input-error')) {
      fetchSNInput.classList.remove('input-error');
    }
    fetchErrSN.hidden = true;
    //3.显示验证slider
    fetchDataSlider.disabled = false;
  });

  fetchDataSlider.addEventListener('input', function(){
    fetchDataSlider.style['background-size'] = fetchDataSlider.value + '% 100%';
  });
  fetchDataSlider.addEventListener('change', function () {
    fetchDataSlider.style['background-size'] = fetchDataSlider.value + '% 100%';
    //1.如果没滑到底什么都不干
    if (fetchDataSlider.value != '100') {
      clearSlider();
      fetchDataSlider.disabled = false;
      return;
    }
    //2.滑到底了，验证按钮有效
    fetchDataButton.disabled = false;
    fetchDataSlider.disabled = true;
    domSliderTip.hidden = true;
  });

  function clearSlider()
  {
    fetchDataSlider.value = 0;
    fetchDataSlider.style['background-size'] = fetchDataSlider.value + '% 100%';
    fetchDataSlider.disabled = true;
    domSliderTip.hidden = false;
    fetchDataButton.disabled = true;
  }
  function init() {
    divCheck.hidden = false;
    divPass.hidden = true;
    divInactive.hidden = true;
    divFailed.hidden = true;
    fetchSNInput.value = '';
    clearSlider();
  }

  $('#recheck-button').click(function () {
    init();
  });

  fetchDataButton.addEventListener('click', function () {
    //1.获取SN
    check_sn_data.sn = fetchSNInput.value;
    //2.开始发请求
    fetch('https://imkey.online:1000/imkey/deviceSnCheck', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*'
      },
      body: JSON.stringify(check_sn_data)
    })
      .then(response => response.json())
      .then(data => {
        // 3.1 正确处理并显示数据
        if (data._ReturnData.snCheckResult)
        {
          state = 'inactive';
          if (data._ReturnData.isActivate)
          {
            state = 'pass';
            imkeyTime = data._ReturnData.activateTime;
          }
        }
        else
          state = 'failed';
        
        divCheck.hidden = (state == 'default' ? false : true);
        divPass.hidden = (state == 'pass' ? false : true);
        divInactive.hidden = (state == 'inactive' ? false : true);
        divFailed.hidden = (state == 'failed' ? false : true);

        if (state == 'pass') {
          let text = langAttributeValue == 'zh-CN' ? '设备激活时间：' : 'Device Activation Date: ';
          let time = langAttributeValue == 'zh-CN' ? formatDate(imkeyTime) : imkeyTime;
          document.getElementById('imkey-time').innerHTML = text + time;
        }
      })
      .catch(error => {
        //3.2  错误处理并显示数据
        document.getElementById('err-msg').innerHTML = 'Error fetching data. Please try again later。';
        document.getElementById('err-msg').hidden = false;
      });
      
  });
});